import React from "react";
import "./DLServices.css";
import { useNavigate } from "react-router-dom";
import { FcServices } from "react-icons/fc";

import dlImg from "../assets/dlpdf.png";

export default function DLServices() {

  const navigate = useNavigate();

  return (
    <div className="dl-services-wrapper">

      <h2 className="dl-title">
        <FcServices className="dl-icon" /> All DL Related Services
      </h2>

      <div className="dl-divider"></div>

      <div className="dl-services-box">

        <div className="dl-service-card">
          <div className="dl-circle-box" onClick={() => navigate("/dashboard/dlpdf")}>
            <img src={dlImg} alt="DL PDF" draggable="false" />
          </div>
          <p className="dl-service-name">DL Instant PDF</p>
        </div>

      </div>

    </div>
  );
}
